<div class="wrap" id="progression">
    <h4>Mes compétences voile</h4>
    <div class="tabs">
        <fa-icon [icon]="faChevronLeft" class='back' (click)="goBack()"></fa-icon>
        <div class="tabs_content">
            <!-- <div [ngClass]="{tab_active: !tabsActive, tab: tabsActive}">Stages
            </div> -->
            <div [ngClass]="{tab_active: !tabsActive, tab: tabsActive}" (click)="getProgressionLicence(true)">Carnet
            </div>
            <div [ngClass]="{tab_active: tabsActive, tab: !tabsActive}" (click)="getProgressionLicence(false)">Ma
                progression
            </div>

        </div>
    </div>

    <app-skeleton-skills *ngIf="isLoading">
    </app-skeleton-skills>

    <p *ngIf="!isLoading && (myProgression === null ||  myProgression?.length === 0 ||  myProgression === undefined)"
        [style.width.%]="70" [style.margin]="'auto'">Vous
        n'avez
        encore pas de compétences
        validées.</p>

    <app-my-skills-table
        *ngIf="myProgression && myProgression?.length > 0 && myProgression !== undefined &&  myProgression !== null"
        [progression]=" myProgression" [baseUrl]="baseUrl"></app-my-skills-table>
    <!-- <mat-accordion *ngIf="myProgression">
        <mat-expansion-panel *ngFor="let p of myProgression">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <strong> {{p.support.supportName}}</strong>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-accordion *ngIf="p.levels">
                <mat-expansion-panel *ngFor="let l of p.levels">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{l.levelName}}
                        </mat-panel-title>
                        <mat-panel-description>
                            {{l.levelDescription}}
                        </mat-panel-description>

                    </mat-expansion-panel-header>

                    <mat-accordion *ngIf="l.categories">
                        <mat-expansion-panel *ngFor="let c of l.categories">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="title_category">
                                        <p>{{c.categorieName}}</p>
                                        <fa-icon [icon]="faCheckCircle"
                                            [ngClass]="{valid: isValid(c.objectifs[0]), not_valid: !isValid(c.objectifs[0])}">
                                        </fa-icon>
                                    </div>
                                </mat-panel-title>

                            </mat-expansion-panel-header>
                            <ng-container *ngFor="let o of c.objectifs">
                                <h5>{{o.objectifName}}</h5>
                                <div class="objectifs">
                                    <ng-container *ngFor="let so of o.sousObjectifs">
                                        <p>
                                            <fa-icon [icon]="faCheckCircle"
                                                [ngClass]="{valid: so.validations,  not_valid: !so.validations}">
                                            </fa-icon>
                                            {{so.sousObjectifName}}
                                        </p>
                                        <p *ngIf="so.validations" class="objectif_date">Délivré le
                                            <strong> {{so.validations?.dateValidation | date}}</strong> par
                                            <strong>{{so.validations?.moniteurLicencieID}}</strong>
                                        </p>
                                    </ng-container>
                                </div>
                            </ng-container>

                        </mat-expansion-panel>

                    </mat-accordion>

                </mat-expansion-panel>

            </mat-accordion>
        </mat-expansion-panel>

    </mat-accordion> -->

</div>